import { usePositionOptions } from "@/services/backend/omni/position/lib/use-position-options";
import { PositionsTable } from "@/services/backend/omni/position/components/positions-table";
import { useScopeOfWorkPositionsTableProps } from "@/services/backend/omni/offer/lib/use-scope-of-work-positions-table-props";
import { Offer } from "@/services/backend/omni/offer/types/offer";
import { ScopeOfWork } from "@/services/backend/omni/scope-of-work/types/scope-of-work";
import { wrhPositionsTableConfig } from "@/services/backend/omni/servicekindrules/wrh-positions-table-config";

/**
 * OfferScopeOfWorkPositionsTable shows and edits the positions of a scope
 * of work of the WRH offer.
 */
export function OfferScopeOfWorkPositionsTable({
  offer,
  scopeOfWork,
}: {
  offer: Offer;
  scopeOfWork: ScopeOfWork;
}) {
  const props = useScopeOfWorkPositionsTableProps(offer, scopeOfWork);
  const options = usePositionOptions(
    offer.companyId,
    offer.serviceKind,
    scopeOfWork.serviceVariation,
  );

  return (
    <PositionsTable
      config={wrhPositionsTableConfig(
        scopeOfWork.serviceVariation,
        scopeOfWork.positions,
        options,
      )}
      {...props}
    />
  );
}
